import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      position: 'absolute',
      zIndex: 400,

      width: '100%',
      padding: '1rem',

      textAlign: 'center',

      '& > a': {
        background: theme.palette.background.paper,
        color: theme.palette.primary.dark,
        borderRadius: 5,

        width: '80%',
        maxWidth: '30rem',
        lineHeight: '3.2rem',
        margin: '0 auto',

        fontSize: '1.2rem',
        fontWeight: 600,
        lineSpacing: '0.5',
        fontFamily: theme.typography.body1.fontFamily,

        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.8rem',

        '& > svg': {
          fontSize: '1.4rem',
          color: theme.palette.secondary.main,
        },
      },
    },
  }),
)
